var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "TradeLogo",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-trade-logo","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M125.1 250l-2.5-1.5c-1-.6-24.9-14.8-50.8-47.9C48.1 170.2 18.2 117.3 11 38.2l-.2-2.5 2.1-1.5C14.8 32.8 60 .3 125.4.3c38.4 0 75.8 11.3 111 33.7l2.1 1.4v2.5c0 1.4-.7 34-14.7 76.4-12.9 39.2-40.1 94.3-96.3 134.1l-2.4 1.6zM20.3 40c7.4 75.5 35.9 125.9 58.6 155.1 20.1 25.8 39.2 39.7 45.8 44.1 52.6-38.3 78.3-90.5 90.5-127.8 11.4-34.6 13.7-62.9 14.1-71.2-33.1-20.5-68.1-31-104-31-54.8.1-95.6 24.6-105 30.8z"/>
  <path d="M124.9 209l-1.8-1.1c-.7-.4-18.4-10.9-37.4-35.3C68.2 150.3 46.3 111.4 41 53.2l-.2-1.9 1.5-1.1c1.4-1 34.6-24.9 82.8-24.9 28.3 0 55.8 8.3 81.7 24.8l1.6 1V53c0 1-.5 25-10.8 56.2-9.5 28.8-29.5 69.4-70.9 98.7l-1.8 1.1zM47.8 54.5c5.4 55.5 26.4 92.6 43.1 114.1 14.8 19 28.9 29.2 33.7 32.5 38.7-28.2 57.6-66.6 66.6-94 8.4-25.4 10.1-46.2 10.4-52.4-24.4-15.1-50.1-22.8-76.5-22.8-40.4 0-70.4 18.1-77.3 22.6z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/trade-logo.svg